import { render, staticRenderFns } from "./card_hist.vue?vue&type=template&id=40c75e7a&scoped=true&"
import script from "./card_hist.vue?vue&type=script&lang=js&"
export * from "./card_hist.vue?vue&type=script&lang=js&"
import style0 from "./card_hist.vue?vue&type=style&index=0&id=40c75e7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c75e7a",
  null
  
)

export default component.exports